import { Images } from '../../config/images';
import { ImageIcon } from './ImageIcon';

export const SelfDirectedIra = (props) => <ImageIcon {...props} src={Images.selfDirectedIra} />;
